import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;
	height: 858px;
	overflow: scroll;
	padding: 0 40px 40px;
	margin-top: 20px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledSkillsCategory = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;

	& > ${Text} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledSkillsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
	gap: 20px;
	justify-content: space-between;
	width: 100%;
	margin: 0 auto;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export { StyledContainer, StyledSkillsCategory, StyledSkillsGrid };
